import React from 'react';
import SecurityBadge from '../components/how-it-works/SecurityBadge';
import StepsSection from '../components/how-it-works/StepsSection';
import MVNOCompare from '../components/how-it-works/MVNOCompare';

export default function HowItWorks() {
  return (
    <div className="bg-white">
      <div className="bg-gradient-to-br from-blue-600 to-indigo-700 py-24 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight">
            How SwitchFree Works
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            We finance your carrier buyout so you can immediately move to an affordable MVNO — no waiting, no out-of-pocket costs upfront.
          </p>
        </div>
      </div>

      <StepsSection />
      <MVNOCompare />
      <SecurityBadge />
    </div>
  );
}